class Parameter {
  constructor(el, opt) {
    this.el = el;
    if($(this.el).length){
      this.event();
    }
  }
  event(){
    const urlParams = new URLSearchParams(window.location.search);
    const selectedValue = urlParams.get('id');
  
    if (selectedValue) {
      const selectBox = document.querySelector('#parameter select');
      selectBox.style.color = 'rgb(51, 51, 51)';
      
      selectBox.value = selectedValue;
    }
  }
}
